import React from 'react';
import {
  NavItem,
  Nav,
  Col,
  Tab,
  Row,
} from 'react-bootstrap';
import { browserHistory } from 'react-router';
import TourHotelSelectTab from './TourHotelSelectTabContainer';
import TourHotelSendTab from './TourHotelSendTabContainer';
import TourHotelManageTab from './TourHotelManageTab';

class TourHotelTab extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }
  componentDidMount(){
    this.props.requestBidsets(this.props.tour.id)
  }
  handleSelect(detailTab) {
    if (detailTab === 1) {
      // Handle legacy tab numbering
      const url = `/tours/${this.props.tour.id}/hotels/2`;
      browserHistory.push(url);
      return;
    }
    const url = `/tours/${this.props.tour.id}/hotels/${detailTab}`;
    browserHistory.push(url);
  }
  proposalCall=()=>{
    this.props.requestProposals(this.props.tour.id)
  }

  render() {
    const style = {'color':'green'};
    const navStyle = {'display':'block','width':'10px'}
    const itemStyle = {'clear':'both','display':'inline-block','overflow':'hidden','white-space':'nowrap'};
    const activeKey = this.props.detailTab ? this.props.detailTab : '2';
    return (
      <div className="col-sm-12 planner">
        <Tab.Container
          id="tabs-with-dropdown"
          activeKey={activeKey}
          onSelect={this.handleSelect}
        >
          <Row className="clearfix">
            <Col sm={4}>
              <Nav bsStyle="tabs" style={navStyle}>
                <NavItem eventKey="2" style={itemStyle}>
                  <span>1</span> Select Hotels
                 </NavItem>
                <NavItem eventKey="3" style={itemStyle}>
                  <span>2</span> Request Bids
                 </NavItem>
                <NavItem eventKey="4" style={itemStyle} onClick={this.proposalCall} >
                  <span>3</span> Manage Bids
                 </NavItem>
              </Nav>
            </Col>
            <Col sm={8}>
                {activeKey==2?(
                  <div><br/><br/>
                    <span bsStyle="tabs" style={style}>A. Click on a city to get started.</span><br/>
                    <span bsStyle="tabs" style={style}>B. In the grid, set in/out dates for your group by room type. </span><br/>
                    <span bsStyle="tabs" style={style}>C. If you need additional rooms or varying in/out date, add them by clicking Add Rooms Button.</span><br/>
                    <span bsStyle="tabs" style={style}>D. Click Save.</span><br/>
                    <span bsStyle="tabs" style={style}>E. If you have more than one subgroup, follow the above steps for the next subgroup.</span><br />
                    <span bsStyle="tabs" style={style}>F. Click Add Note for notes specific to this city only.</span><br/> 
                    <span bsStyle="tabs" style={style}>G. Click check box next to hotel name to add to your bid list.</span>
                  </div>
                ):('')}
                {activeKey==3?(
                  <div><br/><br/>
                    <span bsStyle="tabs" style={style}>A. Click Request bid button under each brand.</span><br/>
                    <span bsStyle="tabs" style={style}>B. Choose to Send to Brand manager or directly to Hotel.</span><br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;<span bsStyle="tabs" style={style}>(Note, Unbranded you can only send to hotel directly.)</span><br/>
                    <span bsStyle="tabs" style={style}>C. Fill in contact info and click send.</span><br/>
                    <span bsStyle="tabs" style={style}>D. Repeat for each Brand.</span>
                  </div>
                ):('')}
                {activeKey==4?(
                  <div><br/><br/>
                    <span bsStyle="tabs" style={style}>A. Click Share to send to clients for review or:</span><br/>
                    <span bsStyle="tabs" style={style}>B. Click Download to download options list or itin. </span><br/>
                    <span bsStyle="tabs" style={style}>C. Once decisions have been made, click View  Bid to Accept or Decline.</span><br/>
                    <span bsStyle="tabs" style={style}>D. Once all hotels are booked, click download to download itin.</span>
                  </div>
                ):('')}
            </Col>
            <Col sm={12}>
              <Tab.Content animation>
                <Tab.Pane eventKey="2" mountOnEnter>
                  <TourHotelSelectTab tour={this.props.tour} />
                </Tab.Pane>
                <Tab.Pane eventKey="3" mountOnEnter>
                  <TourHotelSendTab
                    tour={this.props.tour}
                    detailTab={this.props.detailTab}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="4" mountOnEnter>
                  <TourHotelManageTab
                    tour={this.props.tour}
                    detail={this.props.detailSelect}
                    detailTab={this.props.detailTab}
                    isTourManager={false}
                    readOnly={this.props.readOnly}
                  />
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    );
  }
}

export default TourHotelTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelTab.js